<template><div>Please refresh!</div></template>

<script setup>
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import useApi from "../utils/apiCalls.js";

const router = useRouter();

// Events
const emit = defineEmits(["error", "scroll"]);
const { apiGetRequest } = useApi(emit);

// Check for active trip
var isReady = ref(false);
var tripId = ref(null);
const load = () => {
  apiGetRequest({
    path: "/trips",
    onSuccess: data => {
      tripId.value = data;
      isReady.value = true;
    },
    onError: error => {
      emit("error", error, "Home:load");
    },
  });
};
load();
watch(
  () => isReady.value,
  val => {
    if (val) {
      // Redirect accordingly
      if (tripId.value > 0) {
        router.push({ name: "trip", params: { tripId: tripId.value } });
      } else {
        router.push({ name: "trips" });
      }
    }
  }
);
</script>
